import React from 'react';
import moment from 'moment';

import { IDrawEvent } from '../../inputs/Timeline/Timeline.model';
import { dateTimeFormat } from '../../../helpers/time';

interface Props {
  drawMode: boolean;
  drawRecord: IDrawEvent;
}

const RecorderDrawSummary: React.FC<Props> = ({
  drawMode,
  drawRecord,
}) => {
  if (!drawRecord || !drawMode) {
    return null;
  }

  return (
    <div>
      <div style={{ padding: '12px 0 20px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        {drawRecord.startTime && <span>Start: {dateTimeFormat(drawRecord.startTime)}</span>}
        {drawRecord.endTime && <span>End: {dateTimeFormat(drawRecord.endTime)}</span>}
        {drawRecord.startTime && drawRecord.endTime && (
          <span>
            Duration: {Math.round((moment(drawRecord.endTime).unix() - moment(drawRecord.startTime).unix())) / 60} minutes
          </span>
        )}
      </div>
    </div>
  );
};

export default RecorderDrawSummary;
